<project-item-tag>

<div class="container_project-info margin-spacing-1_bottom">
<span class="status_label project_status_label-{props.room.project_state} margin-spacing-1_right"></span>

<ul class="information_list">
	<li class="information_list-item "><span class="information_list-item-title">プロジェクトID:</span>{props.room.project_id}</li>
</ul><!--/.information_list-->
	
	<!-- <div class="btn_favorite js-toggle_switch"></div>-->
</div><!--/.container_project-info-->
<h2 class="matter_heading margin-spacing-2_bottom"><a hreF="{`/project/detail/${props.room.project_id}`}">{props.room.project_title}</a></h2>

<div class="container_schedule-info">
	<div class="button button-secondary-mini"><a href="{`/chat/room/${props.room.id}`}">チャットルームへ</a></div>
</div><!--/.container_schedule-info-->
</project-item-tag>
